import React from "react";
import { Illustration, Typography } from "Components/shared/oneui";
import RefreshBtn from "./RefreshBtn";

const NoDowntime = ({ show, updateFilter }) => {
  return (
    <div className="twside-flex twside-justify-center twside-items-center twside-flex-col twside-gap-16 twside-mt-48">
      <Illustration height="140px" type="wifi" />
      <Typography
        variant="SH1"
        className="twside-text-center twside-text-green-800"
      >
        All Payment Modes are Active
      </Typography>
      <div className="twside-hidden t:twside-block twside-text-center">
        <RefreshBtn updateFilter={updateFilter} />
      </div>
      <Typography
        variant="P1"
        className="twside-text-center twside-mt-24 t:twside-mx-100"
      >
        Stay updated with the connection status of all your payment modes
      </Typography>
      {show && (
        <div className="t:twside-hidden twside-fixed twside-bottom-0 twside-w-full twside-text-center">
          <RefreshBtn isMobile={true} updateFilter={updateFilter} />
        </div>
      )}
    </div>
  );
};

export default NoDowntime;
